export const OCSURL = 'https://ocs.bahai.us/ocs/';
